import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconEye = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-eye" data-icon="icon-eye" aria-hidden="true" {...props} ref={ref}><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>);
});

IconEye.displayName = 'IconEye';
